var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-footer',{staticClass:"footer font-weight-medium",attrs:{"height":"50"}},[_c('p',{staticClass:"footer__text"},[_vm._v("© Copyright "+_vm._s(new Date().getFullYear())+" | GeoChef - Todos los derechos reservados")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }